/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    a: "a",
    span: "span",
    hr: "hr",
    h3: "h3",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h2, {
    id: "overview",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#overview"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), React.createElement(_components.a, {
    href: "#overview",
    "aria-label": "overview permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<span class=\"SVGIcon SVGIcon--24px\"><svg data-id=\"SVG_LINK__24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M9.3 14.7l5.4-5.4m.5 3.3l.8.7L20.3 9c.6-.5.6-1.5 0-2l-3.2-3.3c-.6-.6-1.6-.6-2.2 0L10.6 8l.8.7m-2.6 2.7l-.8-.8L3.7 15c-.6.6-.6 1.6 0 2.1l3.2 3.3c.6.6 1.6.6 2.2 0l4.3-4.3-.8-.8\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span>"
    }
  })), "Overview"), "\n", React.createElement(_components.hr), "\n", React.createElement(_components.h3, {
    id: "introduction",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#introduction"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), React.createElement(_components.a, {
    href: "#introduction",
    "aria-label": "introduction permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<span class=\"SVGIcon SVGIcon--24px\"><svg data-id=\"SVG_LINK__24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M9.3 14.7l5.4-5.4m.5 3.3l.8.7L20.3 9c.6-.5.6-1.5 0-2l-3.2-3.3c-.6-.6-1.6-.6-2.2 0L10.6 8l.8.7m-2.6 2.7l-.8-.8L3.7 15c-.6.6-.6 1.6 0 2.1l3.2 3.3c.6.6 1.6.6 2.2 0l4.3-4.3-.8-.8\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span>"
    }
  })), "Introduction"), "\n", React.createElement("section", null, React.createElement("p", null, "GraphQL resource limitation, and logger. Provides plugins for federated graphQL servers.\nPlugin for federated subgraph sends individual cost, depth, length analytics over header responses.\nGateway plugin aggregates costs, gets query depth, and query length.\nPlugins have the ability to protect queries by blocking queries that are too expensive")), "\n", React.createElement(_components.h3, {
    id: "query-analytics",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#query-analytics"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), React.createElement(_components.a, {
    href: "#query-analytics",
    "aria-label": "query analytics permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<span class=\"SVGIcon SVGIcon--24px\"><svg data-id=\"SVG_LINK__24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M9.3 14.7l5.4-5.4m.5 3.3l.8.7L20.3 9c.6-.5.6-1.5 0-2l-3.2-3.3c-.6-.6-1.6-.6-2.2 0L10.6 8l.8.7m-2.6 2.7l-.8-.8L3.7 15c-.6.6-.6 1.6 0 2.1l3.2 3.3c.6.6 1.6.6 2.2 0l4.3-4.3-.8-.8\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span>"
    }
  })), "Query Analytics"), "\n", React.createElement("section", null, React.createElement("p", null, "When making a graphQL request, plugins will provide response headers with graphQL query metadata.\nBelow is a list of provided data")), "\n", React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th, {
    align: "left"
  }, "Header"), React.createElement(_components.th, {
    align: "left"
  }, "Description"))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-cost"), React.createElement(_components.td, {
    align: "left"
  }, "Cost of query")), React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-depth"), React.createElement(_components.td, {
    align: "left"
  }, "Depth of query")), React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-length"), React.createElement(_components.td, {
    align: "left"
  }, "Length (in bytes) of query")), React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-max-cost"), React.createElement(_components.td, {
    align: "left"
  }, "Max cost allowed per query")), React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-max-depth"), React.createElement(_components.td, {
    align: "left"
  }, "Max depth allowed per query")), React.createElement(_components.tr, null, React.createElement(_components.td, {
    align: "left"
  }, "X-query-max-length"), React.createElement(_components.td, {
    align: "left"
  }, "Max length allowed per query")))), "\n", React.createElement(_components.h3, {
    id: "sample-cost-violation-response",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    "aria-hidden": "true",
    tabIndex: "-1",
    href: "#sample-cost-violation-response"
  }, React.createElement(_components.span, {
    className: "icon icon-link"
  })), React.createElement(_components.a, {
    href: "#sample-cost-violation-response",
    "aria-label": "sample cost violation response permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<span class=\"SVGIcon SVGIcon--24px\"><svg data-id=\"SVG_LINK__24\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M9.3 14.7l5.4-5.4m.5 3.3l.8.7L20.3 9c.6-.5.6-1.5 0-2l-3.2-3.3c-.6-.6-1.6-.6-2.2 0L10.6 8l.8.7m-2.6 2.7l-.8-.8L3.7 15c-.6.6-.6 1.6 0 2.1l3.2 3.3c.6.6 1.6.6 2.2 0l4.3-4.3-.8-.8\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span>"
    }
  })), "Sample Cost Violation Response"), "\n", React.createElement("section", null, React.createElement("p", null, "If resource limitation is on and a graphQL query fails validation, such as being too expensive,\ntoo deep, or too long, you would receive a message as shown below")), "\n", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<div class=\"gatsby-remark-copy-button-container\">\n              <button\n                class=\"gatsby-remark-copy-button\"\n                onClick=\"copyToClipboard(`{\n  &quot;error&quot;: {\n    &quot;extensions&quot;: {\n      &quot;details&quot;: {\n        &quot;url&quot;: &quot;/graphql&quot;,\n        &quot;datasource&quot;: &quot;api-gateway&quot;,\n        &quot;datasourceResponseStatusCode&quot;: 429,\n        &quot;datasourceMessage&quot;: {\n          &quot;message&quot;: &quot;Your query failed validation rules. Check the details below and consider removing some fields&quot;,\n          &quot;details&quot;: {\n            'query-cost': 1500,\n            'query-depth': 5,\n            'query-length': 300,\n            'max-cost': 1000,\n            'max-depth': 50,\n            'max-length': 2000,\n          }\n        }\n      },\n      &quot;code&quot;: &quot;DATA_SOURCE_ERROR&quot;\n    }\n  }\n}`, this)\"\n              >\n                <svg class=\"copy-icon\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z\"></path></svg><svg class=\"copy-icon success-icon\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z\"></path></svg>\n              </button>\n            </div>"
    }
  }), "\n", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<div class=\"gatsby-highlight\" data-language=\"text\"><pre style=\"counter-reset: linenumber NaN\" class=\"language-text line-numbers\"><code class=\"language-text\">{\n  \"error\": {\n    \"extensions\": {\n      \"details\": {\n        \"url\": \"/graphql\",\n        \"datasource\": \"api-gateway\",\n        \"datasourceResponseStatusCode\": 429,\n        \"datasourceMessage\": {\n          \"message\": \"Your query failed validation rules. Check the details below and consider removing some fields\",\n          \"details\": {\n            'query-cost': 1500,\n            'query-depth': 5,\n            'query-length': 300,\n            'max-cost': 1000,\n            'max-depth': 50,\n            'max-length': 2000,\n          }\n        }\n      },\n      \"code\": \"DATA_SOURCE_ERROR\"\n    }\n  }\n}</code><span aria-hidden=\"true\" class=\"line-numbers-rows\" style=\"white-space: normal; width: auto; left: 0;\"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></span></pre></div>"
    }
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
